import { jsx as _jsx } from "react/jsx-runtime";
import { IconButton } from "@mui/material";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
export const AccordionExpandButton = ({ disabled, expanded, isCollapsible }) => {
    if (!isCollapsible)
        return null;
    return (_jsx(IconButton, Object.assign({ disabled: disabled, size: "medium", color: "primary" }, { children: expanded ? _jsx(ExpandLessIcon, {}) : _jsx(ExpandMoreIcon, {}) })));
};
